import React, { useContext } from 'react';

import { Tooltip } from 'antd';

import { ListContext } from '@contexts/ListContext';

import NwIcon from '@components/Gui/NwIcon';

import TemplateSelectorPopover from './TemplateSelectorPopover';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const IconTemplateSelector = ({ icon, onClick, placement, template, trigger, templateArea, size }) => {
    const { templates } = useContext(ListContext).cachedList;
    const filteredTemplatesByType = templates.items.filter((template) => template.area === templateArea);

    const handleSelectTemplate = async (templateID) => {
        return await onClick(templateID);
    };

    const getIcon = () => {
        if (icon) {
            return icon;
        }
        return byPrefixAndName.fasl['file-pdf'];
    };

    if (filteredTemplatesByType.length === 0) {
        return (
            <Tooltip title="No available print templates">
                <NwIcon disabled icon={getIcon()} size={size} />
            </Tooltip>
        );
    }
    if (filteredTemplatesByType.length === 1) {
        return (
            <NwIcon
                pointer
                icon={getIcon()}
                onClick={() => handleSelectTemplate(filteredTemplatesByType[0].id)}
                size={size}
            />
        );
    }
    if (filteredTemplatesByType.length > 1) {
        return (
            <TemplateSelectorPopover
                onSelect={handleSelectTemplate}
                placement={placement}
                templates={filteredTemplatesByType}
                trigger={trigger}
            >
                <NwIcon pointer icon={getIcon()} size={size} />
            </TemplateSelectorPopover>
        );
    }
};

export default IconTemplateSelector;
